import { filter } from "lodash";
import RateCreate from "pages/Rate/RateCreate";
import RateList from "pages/Rate/RateList";
import { boolean, mixed, number, object, string } from "yup";

export enum AfDataType {
  NUMBER,
  TEXT,
  TEXTAREA,
  DATETIME,
  DATE,
  FILE,
  DB,
  VIEW,
  BOOLEAN,
  SELECT,
  EDIT,
  BUTTON,
  CUSTOM,
  TIME,
  CHECKBOX,
}
const ADT = AfDataType;

const viewActionColumn = {
  label: "Action",
  key: "id",
  render: (_) => {
    return `<a>${_}</a>`;
  },
  type: ADT.VIEW,
  view: true,
  add: false,
  edit: false,
  filter: false,
  sort: false,
};

/* === Start === */
export const GenericColumnData: any = {
  category: {
    tableColumnData: [
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Name",
        key: "name",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Slug",
        key: "slug",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },

      viewActionColumn,
    ],
    validationSchema: object().shape({
      name: string().required("Required Field"),
      slug: string().required("Required Field"),
    }),
    initialValues: {
      name: "",
      slug: "",
    },
  },
  subcategory: {
    tableColumnData: [
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Name",
        key: "name",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Slug",
        key: "slug",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Pincode",
        key: "pincode",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      viewActionColumn,
    ],
    validationSchema: object().shape({
      branch_name: string().required("Required Field"),
      address: string().required("Required Field"),
      pincode: string()
        .required("Required Field")
        .matches(/^[1-9][0-9]{5}$/, "Invalid Pincode"),
    }),
    initialValues: {
      branch_name: "",
      address: "",
      pincode: "",
    },
  },
  agent: {
    tableColumnData: [
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: true,
      },
      {
        label: "Employee Code",
        key: "employeeCode",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Password",
        key: "password",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
      },
      {
        label: "Email",
        key: "email",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "First Name",
        key: "firstName",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Last Name",
        key: "lastName",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Gender",
        key: "gender",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Mobile",
        key: "mobile",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Qualification",
        key: "qualification",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Role",
        key: "type",
        type: ADT.DB,
        db: "role",
        db_col: "name",
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Subbranch",
        key: "subbranch",
        type: ADT.DB,
        db: "subbranch",
        db_col: "branch_code",
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Is Active",
        key: "isActive",
        type: ADT.BOOLEAN,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Device ID",
        key: "macId",
        render: (_) => {
          return `<a>${_}</a>`;
        },
        type: ADT.VIEW,
        view: true,
        add: false,
        edit: false,
        filter: false,
        sort: false,
      },
      viewActionColumn,
    ],
    validationSchema: object().shape({
      mobile: number().required("Required Field"),
      pincode: string()
        .required("Required Field")
        .matches(/^[1-9][0-9]{5}$/, "Invalid Pincode"),
      subbranch: number().required("Required Field"),
    }),
    initialValues: {
      employeeCode: "",
      password: "",
      email: "",
      firstName: "",
      lastName: "",
      gender: "",
      mobile: "",
      qualification: "",
      role: "",
      subbranch: "",
      isActive: "",
    },
  },
  user: {
    tableColumnData: [
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: true,
      },
      {
        label: "Full Name",
        key: "name",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: 11,
      },
      {
        label: "Username",
        key: "username",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: false,
        filter: 11,
      },
      {
        label: "Password",
        key: "password",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: false,
      },
      {
        label: "Email",
        key: "email",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Mobile",
        key: "mobileNo",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Role",
        key: "role_name",
        type: ADT.DB,
        db: "role",
        db_col: "name",
        dd_label: "name",
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Subbranch",
        key: "subbranch",
        type: ADT.DB,
        db: "subbranch",
        db_col: "branch_code",
        dd_label: "branch_name",
        view: true,
        add: true,
        edit: true,
      },
      //tpCompany, empCode, dob
      {
        label: "TP Company",
        key: "tpCompany",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Emp Code",
        key: "empCode",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
      },
      {
        label: "DOB",
        key: "dob",
        type: ADT.DATE,
        view: false,
        add: true,
        edit: true,
      },

      {
        label: "Is Third Party",
        key: "isThirdParty",
        type: ADT.BOOLEAN,
        view: true,
        add: true,
        edit: true,
        changeBtn: true,
      },
      {
        label: "Geo Fence Lat/Long",
        key: "punchLocation",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
        changeBtn: true,
      },
      {
        label: "Mobile Mac",
        key: "macId",
        render: (_) => {
          return `<a>${_}</a>`;
        },
        type: ADT.VIEW,
        view: true,
        add: false,
        edit: false,
        filter: false,
        sort: false,
      },
      {
        label: "I_Card",
        key: "i_card",
        render: (_) => {
          return `<a>${_}</a>`;
        },
        type: ADT.VIEW,
        view: true,
        add: false,
        edit: false,
        filter: false,
        sort: false,
      },
      viewActionColumn,
    ],
    validationSchema: object().shape({
      name: string().required("Required Field"),
    }),
    initialValues: {
      password: "",
      email: "",
      name: "",
      mobileNo: "",
      role_name: "",
      subbranch: "",
    },
  },

  vendorpayment: {
    tableColumnData: [
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: true,
      },
      {
        label: "Vendor",
        key: "vendor",
        type: ADT.DB,
        db: "vendor",
        db_col: "vendor_name",
        dd_label: "vendor_name",
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "paymentDate",
        key: "paymentDate",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "invoiceDate",
        key: "invoiceDate",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "fromDate",
        key: "fromDate",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "toDate",
        key: "toDate",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "recvDate",
        key: "recvDate",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "billNo",
        key: "billNo",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "basicAmount",
        key: "basicAmount",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "cgst",
        key: "cgst",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
      },
      {
        label: "sgst",
        key: "sgst",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
      },
      {
        label: "igst",
        key: "igst",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
      },
      {
        label: "finalAmount",
        key: "finalAmount",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "tds",
        key: "tds",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },

      {
        label: "status",
        key: "status",
        type: ADT.SELECT,
        options: [
          { value: "PENDING", label: "PENDING" },
          { value: "VERIFIED", label: "VERIFIED" },
          { value: "PAID", label: "PAID" },
          { value: "REJECTED", label: "REJECTED" },
          { value: "PARTIAL", label: "PARTIAL" },
          { value: "ADVANCE", label: "ADVANCE" },
        ],
        initialValue: "PENDING",
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Payment Mode",
        key: "payType",
        type: ADT.SELECT,
        options: [
          { value: "Cash", label: "Cash" },
          { value: "Bank Transfer", label: "Bank Transfer" },
          { value: "UPI", label: "UPI" },
          { value: "Cheque", label: "Cheque" },
          { value: "Other", label: "Other" },
        ],
        initialValue: "Other",
        view: true,
        add: true,
        edit: true,
      },

      {
        label: "refNo",
        key: "refNo",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "remark",
        key: "remark",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Invoice File",
        key: "fileUrl",
        type: ADT.FILE,
        folderName: "vendor_invoices",
        view: true,
        add: true,
        edit: true,
      },
      viewActionColumn,
    ],
    validationSchema: object().shape({
      invoiceDate: string().required("Required Field"),
      fromDate: string().required("Required Field"),
      toDate: string().required("Required Field"),
      recvDate: string().required("Required Field"),
      billNo: string().required("Required Field"),
    }),
    initialValues: {
      invoiceDate: "",
      fromDate: "",
      toDate: "",
      recvDate: "",
      billNo: "",
      payType: "",
    },
  },

  companyexpense: {
    tableColumnData: [
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: true,
      },
      {
        label: "Vendor",
        key: "vendor",
        type: ADT.DB,
        db: "vendor",
        db_col: "vendor_name",
        dd_label: "vendor_name",
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Expense Head",
        key: "head",
        type: ADT.SELECT,
        options: [
          { value: "RENT", label: "RENT" },
          { value: "FINANCE COST", label: "FINANCE COST" },
          { value: "ELECTRICITY", label: "ELECTRICITY" },
          { value: "MOBILE", label: "MOBILE" },
          { value: "STATIONARY", label: "STATIONARY" },
          { value: "REPAIR", label: "REPAIR" },
          { value: "OTHER", label: "OTHER" },
        ],
        initialValue: "OTHER",
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "subHead",
        key: "subHead",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "payDate",
        key: "payDate",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Expense Date",
        key: "billDate",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "fromDate",
        key: "fromDate",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "toDate",
        key: "toDate",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "amount",
        key: "amount",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "cgst",
        key: "cgst",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
      },
      {
        label: "sgst",
        key: "sgst",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
      },
      {
        label: "igst",
        key: "igst",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
      },
      {
        label: "finalTotal",
        key: "finalTotal",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "tds",
        key: "tds",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },

      {
        label: "Pay Status",
        key: "payStatus",
        type: ADT.SELECT,
        options: [
          { value: "PENDING", label: "PENDING" },
          { value: "VERIFIED", label: "VERIFIED" },
          { value: "PAID", label: "PAID" },
          { value: "REJECTED", label: "REJECTED" },
          { value: "PARTIAL", label: "PARTIAL" },
          { value: "ADVANCE", label: "ADVANCE" },
        ],
        initialValue: "PENDING",
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Payment Mode",
        key: "payType",
        type: ADT.SELECT,
        options: [
          { value: "Cash", label: "Cash" },
          { value: "Bank Transfer", label: "Bank Transfer" },
          { value: "UPI", label: "UPI" },
          { value: "Cheque", label: "Cheque" },
          { value: "Other", label: "Other" },
        ],
        initialValue: "Other",
        view: true,
        add: true,
        edit: true,
      },

      {
        label: "remark",
        key: "remark",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "remark2",
        key: "remark2",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      viewActionColumn,
    ],
    validationSchema: object().shape({
      amount: number().required("Required Field"),
    }),
    initialValues: {
      amount: 0,
    },
  },

  //salary columns: employee, advance, leaveDays, holidayDays, base_amount, hra, medical, bonus, holiday_allowance, other_allowance, pf, esi, prof_tax, tds, loan_deduction, leave_deductions, other_deductions, net_salary, salary_month, pay_date, payType, payStatus, remark,
  salary: {
    tableColumnData: [
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: true,
      },
      {
        label: "Employee",
        key: "employee",
        type: ADT.DB,
        db: "user",
        db_col: "name",
        dd_label: "name",
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Advance",
        key: "advance",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Leave Days",
        key: "leaveDays",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Holiday Days",
        key: "holidayDays",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Base Amount",
        key: "base_amount",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "HRA",
        key: "hra",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Medical",
        key: "medical",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Bonus",
        key: "bonus",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Holiday Allowance",
        key: "holiday_allowance",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Other Allowance",
        key: "other_allowance",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "PF",
        key: "pf",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "ESI",
        key: "esi",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Prof Tax",
        key: "prof_tax",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "TDS",
        key: "tds",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Loan Deduction",
        key: "loan_deduction",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Leave Deductions",
        key: "leave_deductions",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Other Deductions",
        key: "other_deductions",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Net Salary",
        key: "net_salary",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Salary Month",
        key: "salary_month",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Pay Date",
        key: "pay_date",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Payment Type",
        key: "payType",
        type: ADT.SELECT,
        options: [
          { value: "Cash", label: "Cash" },
          { value: "Bank Transfer", label: "Bank Transfer" },
          { value: "UPI", label: "UPI" },
          { value: "Cheque", label: "Cheque" },
          { value: "Other", label: "Other" },
        ],
        initialValue: "Other",
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Payment Status",
        key: "payStatus",
        type: ADT.SELECT,
        options: [
          { value: "PENDING", label: "PENDING" },
          { value: "VERIFIED", label: "VERIFIED" },
          { value: "PAID", label: "PAID" },
          { value: "REJECTED", label: "REJECTED" },
          { value: "PARTIAL", label: "PARTIAL" },
          { value: "ADVANCE", label: "ADVANCE" },
        ],
        initialValue: "PENDING",
        view: true,
        add: true,
        edit: true,
      },

      {
        label: "Remark",
        key: "remark",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      viewActionColumn,
    ],
    validationSchema: object().shape({
      base_amount: number().required("Required Field"),
      salary_month: string().required("Required Field"),
    }),
    initialValues: {
      base_amount: "",
      salary_month: "",
    },
  },
  vendor: {
    tableColumnData: [
      viewActionColumn,
      {
        label: "Vendor Code",
        key: "vendor_code",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Vendor Name",
        key: "vendor_name",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: 11,
      },
      {
        label: "Mobile",
        key: "mobile_no",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Branch",
        key: "subbranch",
        type: ADT.DB,
        db: "subbranch",
        db_col: "branch_name",
        dd_label: "branch_name",
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Vendor Type",
        key: "vendorType",
        type: ADT.SELECT,
        options: [
          { value: "Forwader", label: "Forwader" },
          { value: "PDA", label: "PDA" },
          { value: "Rental", label: "Rental" },
          { value: "Airfield", label: "Airfield" },
          { value: "Other", label: "Other" },
        ],
        view: true,
        add: true,
        edit: true,
        filter: 11,
      },
      {
        label: "TDS",
        key: "tds",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Bank Name",
        key: "bank_name",
        type: ADT.TEXT,
        add: true,
        edit: true,
      },
      {
        label: "Bank Branch",
        key: "bank_branch_name",
        type: ADT.TEXT,
        add: true,
        edit: true,
      },
      {
        label: "Bank Acc No",
        key: "account_no",
        type: ADT.TEXT,
        add: true,
        edit: true,
      },
      {
        label: "Bank IFSC",
        key: "ifsc",
        type: ADT.TEXT,
        add: true,
        edit: true,
      },
      {
        label: "Director Name",
        key: "director_name",
        type: ADT.TEXT,
        add: true,
        edit: true,
      },
      {
        label: "Office Addr",
        key: "office_address",
        type: ADT.TEXT,
        add: true,
        edit: true,
      },
      {
        label: "Pincode",
        key: "pin_code",
        type: ADT.TEXT,
        add: true,
        edit: true,
      },
      {
        label: "Company GST",
        key: "company_gst_no",
        type: ADT.TEXT,
        add: true,
        edit: true,
      },
      {
        label: "Supplier GST",
        key: "gstno_client_supplier",
        type: ADT.TEXT,
        add: true,
        edit: true,
      },
      {
        label: "Pan No",
        key: "gst_type",
        type: ADT.TEXT,
        add: true,
        edit: true,
      },
      {
        label: "Email",
        key: "email_id",
        type: ADT.TEXT,
        add: true,
        edit: true,
      },
      {
        label: "Website",
        key: "website_name",
        type: ADT.TEXT,
        add: true,
        edit: true,
      },
      {
        label: "Office Phone",
        key: "officePhone",
        type: ADT.TEXT,
        add: true,
        edit: true,
      },
      //agreementStart, agreementEnd, rent, deposit, rentIncrement
      {
        label: "Agreement Start",
        key: "agreementStart",
        type: ADT.DATE,
        view: false,
        add: true,
        edit: true,
      },
      {
        label: "Agreement End",
        key: "agreementEnd",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Rent",
        key: "rent",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
      },
      {
        label: "Deposit",
        key: "deposit",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
      },
      {
        label: "Rent Increment %",
        key: "rentIncrement",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
      },
      {
        label: "Is Active?",
        key: "isActive",
        type: ADT.BOOLEAN,
        view: true,
        add: true,
        edit: true,
      },
    ],
    validationSchema: object().shape({
      vendor_name: string().required("Required Field"),
      mobile_no: string().required("Required Field"),
    }),
    initialValues: {
      isActive: "",
    },
  },
  nonbranchcontact: {
    //name	email	mobile	alternateMobile	address	proof	type	cityId	
    tableColumnData: [
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: false,
      },
      {
        label: "Name",
        key: "name",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Email",
        key: "email",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Mobile",
        key: "mobile",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Alternate Mobile",
        key: "alternateMobile",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Address",
        key: "address",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Type",
        key: "type",
        type: ADT.SELECT,
        options: [
          { value: "pickup", label: "pickup" },
          { value: "delivery", label: "delivery" },
          { value: "motherbag", label: "motherbag" },
        ],
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "City",
        key: "cityId",
        type: ADT.DB,
        db: "city",
        db_col: "city_name",
        dd_label: "city_name",
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      viewActionColumn,
    ],
    validationSchema: object().shape({
      name: string().required("Required Field"),
      mobile: string().required("Required Field"),
    }),
     initialValues: {
      type: "",
    },
  },
  customer: {
    extra: {
      buttons: ["add", "download"],
    },
    tableColumnData: [
      viewActionColumn,
      {
        label: "Agreement",
        key: "customer_agreement",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: false
      },
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: false,
      },
      {
        label: "Customer Code",
        key: "code",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: 11,
      },
      {
        label: "S/H",
        key: "sh",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: 11,
      },
      {
        label: "Customer Addr",
        key: "address",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Mobile",
        key: "mobile",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Pincode",
        key: "pincode",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "GST No",
        key: "gst",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Pan No",
        key: "pan",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Password",
        key: "password",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Office Email",
        key: "officeEmail",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Website",
        key: "website",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Office Phone",
        key: "officePhone",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Is Active?",
        key: "isActive",
        type: ADT.BOOLEAN,
        view: true,
        add: true,
        edit: true,
      },

      /*{
        label: "Subbranch",
        key: "subbranch",
        type: ADT.DB,
        db: "subbranch",
        db_col: "branch_name",
        view: true,
        add: true,
        edit: true,
      },*/
      {
        label: "updatedBy",
        key: "updatedBy",
        type: ADT.DB,
        db: "user",
        db_col: "name",
        view: true,
        add: false,
        edit: false,
      },
      ...[
        /*"compnay_name|Company Name",
        "office_type|office type",*/
        "director|director",
        "designation|designation",
        "residentAddr|Residence Addr",
        "bankName|Bank Name",
        "bankBranch|Bank Branch",
/*        "share_capital|Share Capital",
        "annual_report_copy|Annual Report Copy",
        "terms_payment_type|Terms Pay Type",
        "service_center_code|Service Center Code",
        "courier_emplyee_name|Courier Emplyee",
        "service_name|Service Name",*/
        "cin|CIN No.",
        "remarks|Remark",
        "aadharDoc|Aadhar No",
        "agreementPlace|Place of Agreement",
      ].map((x) => {
        return {
          label: x.split("|")[1],
          key: x.split("|")[0],
          type: ADT.TEXT,
          view: true,
          add: true,
          edit: true,
        };
      }),
      {
        label: "Agree. Start Date",
        key: "agreementStart",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Agree. End Date",
        key: "agreementEnd",
        type: ADT.DATE,
        view: true,
        add: true,
        edit: true,
      },
      /*{
        label: "Special Fuel",
        key: "IsSpecialfuel",
        type: ADT.BOOLEAN,
        view: true,
        add: true,
        edit: true,
      },
      {
        label: "Special Rate",
        key: "IsSpecialRate",
        type: ADT.BOOLEAN,
        view: true,
        add: true,
        edit: true,
      },*/
      {
        label: "Nagative Ballance",
        key: "negative_balance",
        type: ADT.BOOLEAN,
        view: true,
        add: true,
        edit: true,
      },
    ],
    validationSchema: object().shape({
      code: string().required("Required Field"),
      pincode: string()
        .required("Required Field")
        .matches(/^[1-9][0-9]{5}$/, "Invalid Pincode"),
      address: string().required("Required Field"),
      sh: string().required("Required Field"),
    }),
    initialValues: {
      sh: "",
      code: "",
      pincode: "",
      address: "",
    },
  },
  rate: {
    tableColumnData: [
      {
        label: "From",
        key: "from",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "To",
        key: "to",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Rate",
        key: "rate",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Sunday",
        key: "sunday_rate",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "TDD",
        key: "rate_1030_1230",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Wt Rng",
        key: "wt_range",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Add 10:30",
        key: "addition_1030",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Add Amt",
        key: "addition_amount",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "AWB Chg",
        key: "ab_charge",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "FS(%)",
        key: "f_charge",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "CHC%",
        key: "chc_charge",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },

      {
        label: "Dry Ice",
        key: "diceCharge",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "dg",
        key: "dgCharge",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Pkg",
        key: "pkgCharge",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Pkg 1LT",
        key: "pkg1Charge",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Pkg 4LT",
        key: "pkg2Charge",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Pkg 10LT",
        key: "pkg3Charge",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },

      {
        label: "fov (%)",
        key: "fovCharge",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "insurance (%)",
        key: "insuranceCharge",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "ToPay Rate",
        key: "toPayCharge",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Datalogger Rate",
        key: "dataLoggerRate",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
    ],
    customComponent: RateList,
    customAddComponent: RateCreate,
    validationSchema: object().shape({
      from: number().required("Required Field"),
      to: number().required("Required Field"),
      rate: number().required("Required Field"),
      sunday_rate: number().required("Required Field"),
      rate_1030_1230: number().required("Required Field"),
      wt_range: number().required("Required Field"),
      addition_1030: number().required("Required Field"),
      addition_amount: number().required("Required Field"),
      ab_charge: number().required("Required Field"),
      f_charge: number().required("Required Field"),
      chc_charge: number().required("Required Field"),
      country: number().required("Required Field"),
      state: number().required("Required Field"),
      city: number().required("Required Field"),
      customer: number().required("Required Field"),
      bound: string().required("Required Field"),
      zone: string().required("Required Field"),
      product: number().required("Required Field"),
    }),
    initialValues: {
      from: "",
      to: "",
      rate: "",
      sunday_rate: "",
      rate_1030_1230: "",
      wt_range: "",
      addition_1030: "",
      addition_amount: "",
      ab_charge: "",
      f_charge: "",
      chc_charge: "",
      country: "",
      state: "",
      city: "",
      customer: "",
      bound: "",
      product: "",
      zone: "",
      is_dox: false,
    },
  },
  city: {
    tableColumnData: [
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "City Name",
        key: "city_name",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: 11,
      },
      {
        label: "City Code",
        key: "cityCode",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "State",
        key: "state_name",
        type: ADT.DB,
        db: "state",
        db_col: "state_name",
        dd_label: "state_name",
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      viewActionColumn,
    ],
    validationSchema: object().shape({
      city_name: string().required("Required Field"),
      cityCode: string().required("Required Field"),
    }),
    initialValues: {
      city_name: "",
      cityCode: "",
    },
  },
  pincode: {
    tableColumnData: [
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "pincode",
        key: "pincode",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: 11,
      },
      {
        label: "Zone",
        key: "zone",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "City",
        key: "city",
        type: ADT.DB,
        db: "city",
        db_col: "city_name",
        dd_label: "city_name",
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      viewActionColumn,
    ],
    validationSchema: object().shape({
      pincode: string().required("Required Field"),
      zone: string().required("Required Field"),
    }),
    initialValues: {
      pincode: "",
      zone: "",
    },
  },
  product: {
    tableColumnData: [
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Title",
        key: "title",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Category",
        key: "subCategory",
        type: ADT.DB,
        db: "subcategory",
        db_col: "subCategory",
        dd_label: "name",
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      viewActionColumn,
    ],
    validationSchema: object().shape({
      country_name: string().required("Required Field"),
      zone_name: string().required("Required Field"),
      type_of_courier: string().required("Required Field"),
    }),
    initialValues: {
      country_name: "",
      zone_name: "",
      type_of_courier: "",
    },
  },
  subbranch: {
    //table columns: id, branch_name, address, pincode, gst_no, pan, mobile, sn, branch_code, bankAccName, bankAccType, bankAccNo, bankAddr, bankIfsc, bankMicr
    tableColumnData: [
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Name",
        key: "branch_name",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        sort: true,
        filter: 11,
      },
      {
        label: "Address",
        key: "address",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Pincode",
        key: "pincode",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "GST No",
        key: "gst_no",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "PAN",
        key: "pan",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Mobile",
        key: "mobile",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Alias",
        key: "sn",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: 11,
        sort: true,
      },
      {
        label: "Branch Code",
        key: "branch_code",
        type: ADT.TEXT,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Bank Account Name",
        key: "bankAccName",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Bank Account Type",
        key: "bankAccType",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Bank Account No",
        key: "bankAccNo",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Bank Address",
        key: "bankAddr",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Bank IFSC",
        key: "bankIfsc",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Bank MICR",
        key: "bankMicr",
        type: ADT.TEXT,
        view: false,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      viewActionColumn,
    ],
    validationSchema: object().shape({
      branch_name: string().required("Required Field"),
      branch_code: string().required("Required Field"),
      pincode: string()
        .required("Required Field")
        .matches(/^[1-9][0-9]{5}$/, "Invalid Pincode"),
    }),
    initialValues: {
      branch_name: "",
      branch_code: "",
      pincode: "",
    },
  },

  international_rate: {
    tableColumnData: [
      {
        label: "Id",
        key: "id",
        type: ADT.TEXT,
        view: true,
        add: false,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Zone",
        key: "international_zone",
        type: ADT.DB,
        db: "international_zone",
        db_col: "zone_name",
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Product",
        key: "product_name",
        type: ADT.DB,
        db: "product",
        db_col: "product_name",
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },
      {
        label: "Rate",
        key: "rate",
        type: ADT.NUMBER,
        view: true,
        add: true,
        edit: true,
        filter: true,
        sort: true,
      },

      viewActionColumn,
    ],
    validationSchema: object().shape({
      international_zone: number().required("Required Field"),
      product_name: number().required("Required Field"),
      rate: number().required("Required Field"),
    }),
    initialValues: {
      international_zone: undefined,
      product_name: undefined,
      rate: undefined,
    },
  },
};

console.log(GenericColumnData.customer);
/* === --- === */

/* === Start === */
export const BrachColumnData = [
  {
    label: "Id",
    key: "id",
    type: ADT.TEXT,
    view: true,
    add: false,
    edit: true,
    filter: true,
    sort: true,
  },
  {
    label: "Name",
    key: "branch_name",
    type: ADT.TEXT,
    view: true,
    add: true,
    edit: true,
    filter: true,
    sort: true,
  },
  {
    label: "Addr",
    key: "address",
    type: ADT.TEXT,
    view: true,
    add: true,
    edit: true,
    filter: true,
    sort: true,
  },
  {
    label: "Pincode",
    key: "pincode",
    type: ADT.TEXT,
    view: true,
    add: true,
    edit: true,
    filter: true,
    sort: true,
  },
  viewActionColumn,
];
export const BranchValidationSchema = object().shape({
  branch_name: string().required("Required Field"),
  address: string().required("Required Field"),
  pincode: string()
    .required("Required Field")
    .matches(/^[1-9][0-9]{5}$/, "Invalid Pincode"),
});
export const BranchInitialValues = {
  branch_name: "",
  address: "",
  pincode: "",
};
/* === --- === */
